
define('text!templates/modules/template/assignment/manager/manager-content.html',[],function () { return '<div class="panel-body">\n    <ul class="menu-actions nav nav-pills"></ul>\n    <div class="alert-no-data"></div>\n    <div class="assignment-list"></div>\n</div>\n';});

